import { motion } from "framer-motion";

export const Chapter = ({ number, title, accent = "#F59E0B", children }) => (
  <motion.div
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className="mb-12 sm:mb-16"
    data-testid={`chapter-${number}`}
  >
    <div className="flex items-center gap-5">
      <span
        className="font-grotesk text-sm font-bold tracking-[0.35em]"
        style={{ color: accent }}
      >
        {number}
      </span>
      <span className="h-px flex-1 bg-purple-500/25" />
    </div>
    <h2 className="mt-5 font-syne text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
      {title}
    </h2>
    {children && (
      <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-purple-200/80">
        {children}
      </p>
    )}
  </motion.div>
);
